import {
  Directive,
  ElementRef,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { Subscription, fromEvent } from 'rxjs';

@Directive({
  selector: '[touchOutside]',
})
export class TouchOutsideDirective implements OnInit, OnDestroy {
  @Output() touchOutside = new EventEmitter<void>();
  touchStartSubscription!: Subscription;

  constructor(private elementRef: ElementRef) {}

  ngOnInit() {
    this.touchStartSubscription = fromEvent(document, 'touchstart').subscribe(
      (event: any) => {
        const targetElement = event.target as HTMLElement;
        if (!this.elementRef.nativeElement.contains(targetElement)) {
          this.touchOutside.emit();
        }
      }
    );
  }

  ngOnDestroy() {
    if (this.touchStartSubscription) {
      this.touchStartSubscription.unsubscribe();
    }
  }
}
